import type { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

interface MarkdownPreviewProps {
  content: string;
  className?: string;
}

export const MarkdownPreview: FC<MarkdownPreviewProps> = ({ content, className }) => {
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkBreaks]}
        components={{
          p: ({ children }) => <p style={{ margin: 0 }}>{children}</p>,
          a: ({ children, href }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#E60012',
                textDecoration: 'underline',
              }}
            >
              {children}
            </a>
          ),
          code: ({ children }) => (
            <code
              style={{
                backgroundColor: 'rgba(0,0,0,0.05)',
                padding: '2px 6px',
                borderRadius: '4px',
                fontSize: '14px',
                fontFamily: 'monospace',
              }}
            >
              {children}
            </code>
          ),
          pre: ({ children }) => (
            <pre
              style={{
                backgroundColor: 'rgba(0,0,0,0.05)',
                padding: '12px',
                borderRadius: '8px',
                overflow: 'auto',
                fontSize: '14px',
                fontFamily: 'monospace',
              }}
            >
              {children}
            </pre>
          ),
          ul: ({ children }) => (
            <ul style={{ margin: '4px 0', paddingLeft: '20px', listStyleType: 'disc' }}>
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol style={{ margin: '4px 0', paddingLeft: '20px', listStyleType: 'decimal' }}>
              {children}
            </ol>
          ),
          li: ({ children }) => <li style={{ margin: '2px 0' }}>{children}</li>,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
